import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownGo = () => {
    const cat = categories.find((c) => c.name === selectedCategory);
    if (cat) {
      window.open(cat.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section id="categories" className="w-full bg-background-100/70 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-4">
            <i className="ri-shopping-bag-3-line text-accent-500 text-2xl"></i>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Популярные категории
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Выберите категорию товаров и перейдите к покупкам на нашей основной платформе
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-16 max-w-lg mx-auto">
          <div className="relative w-full">
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="w-full appearance-none px-5 py-3.5 pr-12 rounded-xl bg-background-50 border-2 border-background-300 text-foreground-900 text-sm font-medium cursor-pointer focus:outline-none focus:border-primary-400 transition-colors"
            >
              <option value="" disabled>
                Выберите категорию...
              </option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.name}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <i className="ri-arrow-down-s-line text-foreground-500 text-lg"></i>
            </div>
          </div>
          <button
            onClick={handleDropdownGo}
            disabled={!selectedCategory}
            className="flex-shrink-0 w-12 h-12 rounded-full bg-foreground-950 text-background-50 flex items-center justify-center hover:bg-foreground-800 transition-colors disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden cursor-pointer"
              style={{ aspectRatio: '3/4' }}
            >
              <img
                src={cat.imageUrl}
                alt={cat.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h3 className="text-white font-heading text-lg font-semibold mb-1">
                  {cat.name}
                </h3>
                <span className="text-white/70 text-xs whitespace-nowrap">
                  Перейти в каталог →
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}